export default __webpack_public_path__ + "static/media/block.c83d5b8f.svg";